/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { useNavigate, useParams } from "react-router-dom";
import {
  Layout,
  Card,
  Button,
  Table,
  InputNumber,
  Input,
  Row,
  Col,
  Spin,
} from "antd";
import { RollbackOutlined } from "@ant-design/icons";

import { postAPI, displayMessage } from "../../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../../constants/messages";
import { LAUNDRY_IN_DETAIL, CREATE_LAUNDRY_IN } from "../../../constants/api";

const { Content } = Layout;

function LaundryInAdd() {
  const { laundry_out_id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [laundryOut, setLaundryOut] = useState(null);
  const [items, setItems] = useState([]);

  // Load pending laundry detail
  useEffect(() => {
    setLoading(true);

    postAPI(
      LAUNDRY_IN_DETAIL,
      { laundry_out_id },
      (res) => {
        if (res.status === true) {
          setLaundryOut(res.data);

          const mappedItems = res.data.items.map((row) => ({
            item_id: row.item_id,
            name: row.item.name,
            qty_sent: row.qty_sent,
            qty_received: row.qty_sent,
            damaged: 0,
            missing: 0,
            remark: "",
          }));

          setItems(mappedItems);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
          navigate("/laundry/out");
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to fetch laundry data");
      }
    );
  }, []);

  // Update item row
  const updateItem = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  // Submit receive
  const submitData = () => {
    setLoading(true);

    const payload = {
      laundry_out_id,
      items: items.map((row) => ({
        item_id: row.item_id,
        qty_received: row.qty_received,
        damaged: row.damaged,
        missing: row.missing,
        remark: row.remark,
      })),
    };

    postAPI(
      CREATE_LAUNDRY_IN,
      payload,
      (res) => {
        setLoading(false);
        if (res.status === true) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          navigate("/laundry/out");
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to receive laundry");
      }
    );
  };

  const columns = [
    {
      title: "Item",
      dataIndex: "name",
    },
    {
      title: "Qty Sent",
      dataIndex: "qty_sent",
    },
    {
      title: "Qty Received",
      render: (_, record, index) => (
        <InputNumber
          min={0}
          value={record.qty_received}
          onChange={(val) => updateItem(index, "qty_received", val)}
        />
      ),
    },
    {
      title: "Damaged",
      render: (_, record, index) => (
        <InputNumber
          min={0}
          value={record.damaged}
          onChange={(val) => updateItem(index, "damaged", val)}
        />
      ),
    },
    {
      title: "Missing",
      render: (_, record, index) => (
        <InputNumber
          min={0}
          value={record.missing}
          onChange={(val) => updateItem(index, "missing", val)}
        />
      ),
    },
    {
      title: "Remark",
      render: (_, record, index) => (
        <Input
          value={record.remark}
          onChange={(e) => updateItem(index, "remark", e.target.value)}
        />
      ),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Laundry In (Receive)"
          extra={
            <Button onClick={() => navigate(-1)} type="primary" ghost>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            {laundryOut && (
              <>
                <Row gutter={16} style={{ marginBottom: 16 }}>
                  <Col span={8}>
                    <b>Vendor:</b> {laundryOut.vendor.name}
                  </Col>
                  <Col span={8}>
                    <b>Out Date:</b> {laundryOut.out_date}
                  </Col>
                  <Col span={8}>
                    <b>Total Amount:</b> ₹ {laundryOut.total_amount}
                  </Col>
                </Row>

                <Table
                  columns={columns}
                  dataSource={items}
                  pagination={false}
                  rowKey={(r) => r.item_id}
                />

                <Row style={{ marginTop: 20 }}>
                  <Col span={24}>
                    <Button
                      type="primary"
                      onClick={submitData}
                      loading={loading}
                      style={{ float: "right" }}
                    >
                      Receive Laundry
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default LaundryInAdd;
